var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeGray = function SvgYoutubeGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    "data-name": "Group 1781"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "none",
    "data-name": "Ellipse 48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7b838f",
    d: "M15.5 20.926a45.647 45.647 0 0 1-6.064-.332 1.942 1.942 0 0 1-1.367-1.366A20.5 20.5 0 0 1 7.75 15.5a20.563 20.563 0 0 1 .319-3.727 1.984 1.984 0 0 1 1.366-1.38 47.178 47.178 0 0 1 6.065-.32 45.433 45.433 0 0 1 6.064.333 1.941 1.941 0 0 1 1.367 1.367 19.239 19.239 0 0 1 .319 3.74 20.573 20.573 0 0 1-.319 3.728 1.944 1.944 0 0 1-1.366 1.366 47.286 47.286 0 0 1-6.065.319m-1.545-7.753v4.65l4.034-2.323z",
    "data-name": "Subtraction 1"
  })));
};
export default SvgYoutubeGray;